const THREADS = [
  "Talking Head & Explainers", "Product & Ad Films", "Walkthroughs & Spaces",
  "Social & Trend Edits", "Brand Story & Concept Films", "Podcast & Repurposing",
];

export const TrustedStrip = () => {
  const row = [...THREADS, ...THREADS, ...THREADS];
  return (
    <div data-testid="trusted-strip" className="bg-black pb-20 md:pb-28">
      <p className="text-center text-[10px] font-heading font-bold uppercase tracking-[0.3em] text-white/35 mb-5">
        Every format. Every industry.
      </p>
      <div className="container-x">
        <div className="rounded-full border border-white/10 bg-white/[0.03] py-3.5 overflow-hidden marquee-mask">
          <div className="marquee-track flex items-center w-max">
            {[0, 1].map((half) => (
              <div key={half} className="flex items-center shrink-0">
                {row.map((ind, i) => (
                  <span
                    key={`${half}-${i}`}
                    className="flex items-center font-heading text-sm font-semibold text-white/70 whitespace-nowrap"
                  >
                    <span className="px-5">{ind}</span>
                    <span className="text-[#C8F031] text-[8px]">●</span>
                  </span>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustedStrip;
